import { resourcesList } from './resources-list/resources-list.module';
import { resourcesCategoryList } from './resource-category/resource-category-list.module';
import { subcategoryInformation } from './subcategory-information/subcategory-information.module';
import { resourceSubCategoryAdd } from './resource-subcategory-add/resource-subcategory-add.module';
import { resourceSubCategoryEdit } from './resource-subcategory-edit/resource-subcategory-edit.module';
import { resourcesSubcategoryMain } from './resource-subcategory-main/resource-subcategory-main.module';
import { resourceSubcategoryDetails } from './resource-subcategory-details/resource-subcategory-details.module';
import { resourceCategoryVideoUrlAdd } from './resource-category-video-url-add/resource-category-video-url-add.module';
import { resourceCategoryVideoUrlEdit } from './resource-category-video-url-edit/resource-category-video-url-edit.module';
import { resourceCategoryVideoUrlMain } from './resource-category-video-url-main/resource-category-video-url-main.module';
import { resourcesService } from './resources.service';
import './resources.scss';

export const resources = angular
    .module('components.resources', [
        resourcesList,
        resourcesCategoryList,
        resourceSubCategoryAdd,
        subcategoryInformation,
        resourceSubCategoryEdit,
        resourcesSubcategoryMain,
        resourceSubcategoryDetails,
        resourceCategoryVideoUrlAdd,
        resourceCategoryVideoUrlEdit,
        resourceCategoryVideoUrlMain
    ])
    .service('resourcesService', resourcesService)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/resources/resources.module.js